import { formatGenres, formatEventState } from '@/lib/formaters';
import { formatImage } from './formatImage';

const getTicketLink = (event) => {
	const nowTime = new Date().getTime();
	const endDate = new Date(event.endDate.replace(/-/g, '/')); // `.replace(/-/g, '/')` is to fix safari which fails parsing xxxx-xx-xx date format

	if (endDate.getTime() < nowTime) return null;

	let href = null,
		title = null;

	if (event.acf.ticketLink) href = event.acf.ticketLink;
	else {
		event.acf?.datesEvent?.forEach((perf) => {
			if (!href) {
				const perfEndDate = new Date(perf.date.replace(/-/g, '/'));
				if (perfEndDate.getTime() > nowTime && perf.ticketLink) {
					href = perf.ticketLink;
				}
			}
		});
	}

	if (href && event.acf.ticketButtonText) title = event.acf.ticketButtonText;

	return {
		href,
		title,
	};
};

/**
 *
 * @param event
 * @param locale The current locale code
 * @returns
 */
export const formatEventCard = (event, locale = 'en-US') => {
	const variants = [];

	const cardOptions = event?.acf?.card;
	if (cardOptions?.highlighted) variants.push('highlighted');
	if (cardOptions?.imageFormat === 'portrait') variants.push('portrait');
	if (['small', 'large'].includes(cardOptions?.size)) {
		variants.push(cardOptions.size);
	}

	return {
		id: event.id,
		label: event?.acf?.isAroundTheShow
			? cardOptions?.label ?? { text: event.title }
			: null,
		artist: event.uptitle,
		title: event.title,
		subtitle: event.subtitle,
		link: event.acf.hasDetailPage
			? {
					href: event.link,
			  }
			: null,
		linkTicket: getTicketLink(event),
		isEvent: event.acf.isEvent,
		isAroundTheShow: event.acf.isAroundTheShow,
		text: event.excerpt,
		state: formatEventState(event.acf.state),
		location: event?.locations?.nodes?.[0]?.name ?? '',
		image: formatImage(event.image),
		publics:
			event.acf.publics?.nodes.map(({ id, title, icon: { img } }) => ({
				id,
				title,
				icon: formatImage(img),
			})) ?? [],
		// Needed for filters
		genres: formatGenres(
			event.genres.nodes,
			event.acf.specialMention,
			!!event.acf.production?.nodes?.length
		),
		thematics: event.thematics.nodes,
		// publics: event.publics.nodes,
		seasons: event.seasons.nodes,
		dates: event.datesString,
		variants,
		festival: event?.festivals?.nodes?.map(({ slug }) => slug)?.[0] ?? null,
	};
};
